import { loadPartFile, getService, multiPartPostService, postService, attachAuthHeader} from "../api-service";
import { BASE_URL } from "../environment_url";


//***** Part API Endpoints  ******//

const GET_PART_LIST = "/part/";
const UPLOAD_PART = "/part/import/";
// "/part/store/source/";
const DOWNLOAD_URL = "/part/retrieve/source/";
const ANALYZE_PART_URL = "/part/store/source/metadata/";
const GET_ANALYZER_STATUS = "/part/status/";
const GET_ANALYZER_RESULTS = "/part/retrieve/derived/";
const SEND_MESH_TOPIC = "/publish/MeshAnalysisTopic/"


export function getAllParts(userId) {
    const getPartListsUrl = BASE_URL + GET_PART_LIST;
    return getService(getPartListsUrl, userId);
}

// export function getPartId(userId, fileName, partName) {
//     const getPartIdUrl = BASE_URL + GET_PART_ID + 1 + "/" + partName + "/" + fileName + "/";
//     return postService(getPartIdUrl);
// }

export function uploadPart(partName, fileName, data, userId) {
    const uploadPartUrl = BASE_URL + UPLOAD_PART +userId +"/"+ partName + "/" + fileName + "/";
    return multiPartPostService(uploadPartUrl, data);
}

export function downloadPart(partId, partName) {
    const downloadUrl = BASE_URL + DOWNLOAD_URL + partId + "/" + partName + "/";
    const link = document.createElement("a");
    link.download = partName;
    link.href = downloadUrl;
    link.target= "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function loadPart(partId, partName, sourceType) {
    const isDerivedUrl = sourceType === "derived" ? GET_ANALYZER_RESULTS : DOWNLOAD_URL
    const downloadUrl = BASE_URL + isDerivedUrl + partId + "/" + partName + "/";
    return loadPartFile(downloadUrl);
}

export function analyzePart(partId, partName, params) {
    const analyzeUrl = BASE_URL + ANALYZE_PART_URL + partId + "/" + partName + "/" + params + "/";
    return postService(analyzeUrl, {});
}


export const generateMeshEstimate = (
    partId: number,
    modelName: string
) => {

    const generateEstimateUrl =
        BASE_URL + `/part/${partId}/generate-estimate/`;

    return postService(generateEstimateUrl, {
        modelName
    });
};


/*export const generateCostEstimate = (
    partId: number
) => {

    const url =
        BASE_URL + `/part/${partId}/generate-cost-estimate/`;

    return postService(url, {});
};*/

export const generateCostEstimate = async (
    partId?: number,
    payload?: any
  ) => {
  
    let url = "";
  
    if (partId) {
  
      url =
        BASE_URL +
        `/part/${partId}/generate-cost-estimate/`;
  
    } else {
  
      url =
        BASE_URL +
        `/part/0/generate-cost-estimate/`;
    }
  


    const response = await fetch(
        url,
        {
          method: "POST",
          headers: {
            ...attachAuthHeader(),
            "Content-Type":
              "application/json"
          },
          body: JSON.stringify(
            payload || {}
          )
        }
      );
  
    return response.json();
  };

export function getAnlayzerStatus(partId, partName) {
    const analyzeStatusUrl = BASE_URL + GET_ANALYZER_STATUS + partId + "/" + partName;
    return getService(analyzeStatusUrl, {});
}

export function getAnalyzerResults(partId, name) {
    const analyzerResultsUrl = BASE_URL + GET_ANALYZER_RESULTS + partId + "/" + name + "/";
    return getService(analyzerResultsUrl, {});
}

export function sendMeshTopic(partId, fileName) {
    const meshTopicUrl = BASE_URL + SEND_MESH_TOPIC + partId + "/" + fileName + "/";
    return postService(meshTopicUrl, {});
}

export function updateMeshSetting(partId, fileName, flag) {
    const updateMeshSettingURL = BASE_URL + GET_ANALYZER_STATUS + partId + "?" + fileName + "=" + flag;
    return postService(updateMeshSettingURL, {});
}

export async function deletePart(
    partId: number
  ) {
  
    const response = await fetch(
      BASE_URL + `/part/${partId}/`,
      {
        method: "DELETE",
        headers: {
          ...attachAuthHeader()
        }
      }
    );
  
    return response;
  }